import React from "react";
import { FiAlertCircle } from "react-icons/fi";

const NotFoundScreen = () => (
  <div className="activation-page__card">
    <FiAlertCircle className="activation-page__icon activation-page__icon--error" />
    <h1 className="activation-page__title">Link Not Found</h1>
    <p className="activation-page__subtitle">
      This activation link is invalid or has expired. Please check your email
      for the correct link or contact us at{" "}
      <a href="mailto:support@blikst.com">support@blikst.com</a>.
    </p>
  </div>
);

export default NotFoundScreen;
